import { render, staticRenderFns } from "./CustomersEdit.vue?vue&type=template&id=2b55f22c&scoped=true&"
import script from "./CustomersEdit.vue?vue&type=script&lang=js&"
export * from "./CustomersEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomersEdit.vue?vue&type=style&index=0&id=2b55f22c&lang=scss&scoped=true&"
import style1 from "./CustomersEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55f22c",
  null
  
)

export default component.exports